exports.default = "<div class=\"we_docCenter\"> <br/> <ee-documentcentrequicksearch></ee-documentcentrequicksearch> </div> ";